import React, { Component } from 'react';
import NavigationActionCreator from 'action_creators/navigation';
import GuestInformation from 'views/plugins/checkout/guest_information';
import { t } from 'services/translation';
import CheckoutHeader from '../header';
import Cover from '../cover';
import Submit from '../submit';
import { titleize } from 'lib/string_utils';
import { triggerCheckoutStepScroll } from 'views/plugins/checkout/utils/scroll_utils';
class GuestInformationScreen extends Component {
  componentDidMount() {
    // Trigger scroll to iframe for mobile booking flow
    triggerCheckoutStepScroll();
  }

  componentDidUpdate(prevProps) {
    if (this._hasSaved(prevProps)) {
      NavigationActionCreator.transitionTo(this._nextScreenInfo().screen);
    }
  }

  _hasSaved(prevProps) {
    return this.props.saved === true && prevProps.saved === false;
  }

  _nextScreenInfo = () => {
    const baseScreenPath = 'Views.Plugins.Checkout.Mobile.Screens.';
    const baseLabel = `${t('NEXT')}:`;

    if (this.props.fromSummary) {
      return {
        screen: `${baseScreenPath}CheckoutSummary`,
        label: `${baseLabel} ${titleize(t('REVIEW_DETAILS'))}`,
      };
    }
    if (
      this._shouldSkipPayment() &&
      this.props.shouldShowAdditionalInformation
    ) {
      return {
        screen: `${baseScreenPath}AdditionalInformation`,
        label: `${baseLabel} ${t('ADDITIONAL_INFORMATION')}`,
      };
    } else if (
      this._shouldSkipPayment() &&
      !this.props.shouldShowAdditionalInformation
    ) {
      return {
        screen: `${baseScreenPath}CheckoutSummary`,
        label: `${baseLabel} ${titleize(t('REVIEW_DETAILS'))}`,
      };
    }
    return {
      screen: `${baseScreenPath}CheckoutPayment`,
      label: `${baseLabel} ${titleize(t('PAYMENT_DETAILS'))}`,
    };
  };

  _additionalGuestProps() {
    return {
      collectGuestInfo: this.props.additionalGuestProps.collectGuestInfo,
      numOfGuests: this.props.additionalGuestProps.numOfGuests,
      onChange: this.props.additionalGuestProps.additionalGuestInputChanged,
      bookerGuestName: this.props.additionalGuestProps.bookerGuestName,
      unitsLoaded: this.props.additionalGuestProps.unitsLoaded,
      units: this.props.additionalGuestProps.units,
      brandColor: this.props.additionalGuestProps.brandColor,
    };
  }

  _coverProps() {
    return {
      forInvoice: this.props.forInvoice,
      tourPicture: this.props.tour.picture,
      guideAvatar: this.props.tour.guide_avatar,
      tourName: this.props.tour.name_translation,
      guideName: this.props.tour.guide_name,
      hasResource: this.props.has_resource,
      resourceName: this.props.resource_name,
    };
  }

  _shouldSkipPayment = () => {
    return this.props.priceProps.zero_priced_tour || this.props.paid_in_cash;
  };

  render() {
    const { timer } = this.props;
    return (
      <div className="GuestInformationScreen">
        <CheckoutHeader priceProps={this.props.priceProps} />
        <article className="transition-ctx">
          <Cover {...this._coverProps()} />
          {timer}
          <div className="BookingRequest-form ui form">
            <GuestInformation {...this._additionalGuestProps()} />
            <Submit
              dataTestProp="submit-booking-request"
              label={this._nextScreenInfo().label}
              onSubmit={this.props.onSubmit.bind(this)}
            />
          </div>
        </article>
      </div>
    );
  }
}

export default GuestInformationScreen;
